// Quyền của người đang đăng nhập trong luồng duyệt bảng kê.
// Đọc từ JWT giống cách các màn danh sách khác trong dự án đang làm.
import jwt_decode from "jwt-decode";
import { useMemo } from "react";
import {
  AUTH_TOKEN,
  ROLE_EINVOICE_ADMIN,
  ROLE_EINVOICE_CUA_HANG,
  ROLE_EINVOICE_KE_TOAN,
} from "store/auth/login/actionTypes";

export const useStatementRole = () =>
  useMemo(() => {
    let roles = [];
    try {
      const token = localStorage.getItem(AUTH_TOKEN);
      const info = token ? jwt_decode(token) : null;
      roles = (info?.auth || "").split(",");
    } catch (error) {
      roles = [];
    }
    return {
      // Cửa hàng: lập bảng kê và gửi duyệt
      isRoleStore: roles.includes(ROLE_EINVOICE_CUA_HANG),
      // Kế toán và admin: duyệt / từ chối duyệt bảng kê, duyệt xong mới ký
      isRoleAccountant:
        roles.includes(ROLE_EINVOICE_KE_TOAN) ||
        roles.includes(ROLE_EINVOICE_ADMIN),
    };
  }, []);
